import { StringParam, useQueryParams } from "use-query-params";
import { usePagination } from "@/hooks";
import { ClientsTab, parseClientsTab } from "./tabs";

/**
 * Reads/writes the `?tab` query param that partitions the client list into
 * My Clients (active) / Pending Clients / Archived Clients. Switching tabs resets
 * pagination to page 1. `active` is the default and is encoded as the absence of the param.
 */
export const useClientsTab = () => {
  const [query, setQuery] = useQueryParams({ tab: StringParam });
  const { clearPagination } = usePagination("clients");
  const tab = parseClientsTab(query.tab);

  const setTab = (next: ClientsTab) => {
    if (next === tab) return;
    clearPagination();
    setQuery({ tab: next === "active" ? undefined : next });
  };

  return { tab, setTab };
};
